export default __webpack_public_path__ + "static/media/Emblem_Emerald.ca41c5bf.webp";